import { connect } from 'react-redux';
import get from 'lodash/fp/get.js';
import getOr from 'lodash/fp/getOr.js';
import { getFormValues } from 'redux-form';
import ComponentFormField from '#components/pages/Components/support/form/ComponentFormField/ComponentFormField.jsx';
import getFullyQualifiedFieldName from '#support/utility/form/getFullyQualifiedFieldName.js';
import { modelTypesByForm } from '#src/js/constants/models/modelTypes/index.js';

// TODO: considering updating the wrapper for
// the EnhancedField to cover the additional functionality added here

const mapStateToProps = (state, ownProps) => {
  const { item, field } = ownProps;
  const { name, form, autofiller } = field;
  const fullyQualifiedName = getFullyQualifiedFieldName(item, name);

  let autofilled = false;

  // If this field has autofiller and is used in a Model form, get autofilled state from Redux
  if (form && autofiller && modelTypesByForm[form]) {
    const { makeFieldIsAutofilledSelector } = modelTypesByForm[form];
    const selectFieldIsAutofilled = makeFieldIsAutofilledSelector();
    autofilled = selectFieldIsAutofilled(state, { name });
  }

  // Unified approach: both Component and Model forms use the same patterns
  const visible = !!get(fullyQualifiedName, getOr({}, `form[${form}].visibleFields`, state));
  const value = get(fullyQualifiedName, getFormValues(form)(state) || {});

  return {
    fullyQualifiedName,
    value,
    visible,
    autofilled,
  };
};
export default connect(mapStateToProps)(ComponentFormField);
